import { MemberStatus } from '@aibees/shared/definition';

export function useMemberStatusTexts(status: MemberStatus) {
  const isDisabled = status === MemberStatus.disable;

  const title = isDisabled ? 'Deactivated' : 'Activated';
  const titleUser = isDisabled ? 'Disabled' : 'Active';
  const label = isDisabled ? 'disabling' : 'activating';
  const note1 = isDisabled ? 'Inactive' : 'Active';
  const note2 = isDisabled ? 'reactivation' : 'deactivation';
  const buttonTitle = isDisabled ? 'Save' : 'Save';

  return {
    title,
    titleUser,
    label,
    note1,
    note2,
    buttonTitle,
  };
}
